<!-- ================== APP.VUE ================== -->
<template>
  <div class="main_container">
    <Sidebar />
    <router-view />
  </div>
</template>

<script>
import Sidebar from "./components/SideBar.vue";

document.title = "Saubhagya Rai";

export default {
  components: {
    Sidebar,
  },
};
</script>

<style>
@import url("./assets/bootstrap/css/bootstrap.min.css");
@import url("https://cdn.jsdelivr.net/gh/devicons/devicon@latest/devicon.min.css");

/* <link rel="stylesheet" type='text/css' href="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/devicon.min.css" /> */

@import url("./assets/css/main.css");

/* Main Container Responsive Styles */
.main_container {
  display: flex;
  min-height: 100vh;
}

/* Content area adjustments for sidebar */
.main_content {
  flex: 1;
  margin-left: 300px;
  padding: 40px;
  transition: margin-left 0.3s ease;
}

/* Tablet Styles */
@media (max-width: 1024px) {
  .main_content {
    margin-left: 240px;
    padding: 30px;
  }
}

/* Mobile Styles */
@media (max-width: 768px) {
  .main_container {
    flex-direction: column;
  }

  .main_content {
    margin-left: 0;
    padding: 80px 20px 40px 20px; /* Top padding for mobile menu button */
    width: 100%;
  }
}

/* Small Mobile Styles */
@media (max-width: 480px) {
  .main_content {
    padding: 70px 15px 30px 15px;
  }
}
</style>
